<div class="p-2 connection-container">
  <div class="row mx-0 w-100 mb-3">
    <div class="gis-contact col-md-4 pl-0 d-none d-sm-block">
      <div class="title"></div>
    </div>
    <div class="col-md-4 text-center address">
      <h1>Service Connection Report</h1>
      @if ((propertiesState$ | async).scAddress) {
        <h2>{{ (propertiesState$ | async).scAddress.fullAddress}}</h2>
      }
    </div>
    <div class="col-md-4 d-flex justify-content-end pr-0 print">
      <button class="btn btn-link btn-print" (click)="print()">
        <i class="fas fa-print fa-2x"></i>
      </button>
    </div>
  </div>
  <div class="print-only text-center pb-2">
    Printed on: {{ today | date: 'fullDate'}}
  </div>
  @if (boundingBox) {
    <div class="service-map">
      <!-- base map -->
      <img
        src="{{(appSettings$ | async)['environment.SEBuildingBaseMap']}}export?bbox={{boundingBox.xMin}}%2C{{boundingBox.yMin}}%2C{{boundingBox.xMax}}%2C{{boundingBox.yMax}}&bboxSR=&layers=&layerDefs=&size={{windowWidth}}%2C525&imageSR=&format=png&transparent=true&dpi=96&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image"
        class="service-image">
      <!-- ortho -->
      <img
        src="{{(appSettings$ | async)['environment.SEOrthoBasemap']}}export?bbox={{boundingBox.xMin}}%2C{{boundingBox.yMin}}%2C{{boundingBox.xMax}}%2C{{boundingBox.yMax}}&bboxSR=&layers=show%3A11%2C15%2C23&layerDefs=&size={{windowWidth}}%2C525&imageSR=&format=png&transparent=true&dpi=96&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image"
        class="service-image" [style.opacity]="opacity">
      @if (dblink) {
        <img
          src="{{(appSettings$ | async)['environment.SEParcels']}}export?bbox={{boundingBox.xMin}}%2C{{boundingBox.yMin}}%2C{{boundingBox.xMax}}%2C{{boundingBox.yMax}}&bboxSR=&layers=show%3A0&layerDefs=%7B%220%22%3A%22DBLink%20%3D%20%27{{dblink}}%27%22%7D&size={{windowWidth}}%2C525&imageSR=&format=png&transparent=true&dpi=96&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image"
          class="service-image">
      }
      <!-- TODO: Find a better URL to the right of way / easments dataset-->
      <img
        src="{{(appSettings$ | async)['environment.SERightOfWay']}}export?bbox={{boundingBox.xMin}}%2C{{boundingBox.yMin}}%2C{{boundingBox.xMax}}%2C{{boundingBox.yMax}}&bboxSR=&layerDefs=&size={{windowWidth}}%2C525&imageSR=&format=png&transparent=true&dpi=96&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image&token={{token}}"
        class="service-image">
      <img
        src="{{(appSettings$ | async)['environment.SEServiceConnections']}}export?bbox={{boundingBox.xMin}}%2C{{boundingBox.yMin}}%2C{{boundingBox.xMax}}%2C{{boundingBox.yMax}}&bboxSR=&layers=show%3A2%2C6%2C14&layerDefs=&size={{windowWidth}}%2C525&imageSR=&format=png&transparent=true&dpi=96&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image"
        class="service-image">
    </div>
  }
  <div class="disclaimer">
    <span>Disclaimer: The Rights of Way and Easements dataset has been digitized from historical plans and may be
      missing data or contain inactive features. Where features are indicated, a title search should be conducted to
    confirm their status.</span>
  </div>
  <div class="service-connection mt-4 row mx-0">
    <div class="sanitary mb-4 col-sm-4 px-0 pt-2">
      @if ((propertiesState$ | async).svcconn && (propertiesState$ | async).svcconn.sanitaryConnections) {
        <div>
          @for (sani of (propertiesState$ | async).svcconn.sanitaryConnections; track sani; let i = $index) {
            <div class="connection-group"
              >
              <h3>Sanitary Connection #{{i+1}}</h3>
              <div class="key-pair">
                <span class="label">Location</span>
                <span>{{sanitize(sani.location)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Size</span>
                <span>{{sanitize(sani.size,'mm')}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Length</span>
                <span>{{sanitize(sani.length) | number : '1.2-2'}}m</span>
              </div>
              <div class="key-pair">
                <span class="label">Material</span>
                <span>{{sanitize(sani.material)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Ownership</span>
                <span>{{sanitize(sani.owner)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Installed</span>
                <span>{{sanitize(sani.year)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Prelined Material</span>
                <span>{{sanitize(sani.prelinedMaterial)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Prelined Year</span>
                <span>{{sanitize(sani.prelinedYear)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Capped</span>
                <span>{{sanitize(sani.capped)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Capped Date</span>
                <span>{{sanitize(sani.cappedDate, '', true)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Grouted</span>
                <span>{{sanitize(sani.grouted)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Grout Date</span>
                <span>{{sanitize(sani.groutDate, '', true)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Drawing</span>
                <span>{{sanitize(sani.drawing)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Invert Elev</span>
                <span>{{sanitize(sani.invertElev,'m')}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Asset ID</span>
                <span>{{sanitize(sani.assetId)}}</span>
              </div>
            </div>
          }
        </div>
      }

    </div>
    <div class="storm mb-4 col-sm-4">
      <div class="w-100 pt-2 green">
        @if ((propertiesState$ | async).svcconn && (propertiesState$ | async).svcconn.stormConnections) {
          <div>
            @for (storm of (propertiesState$ | async).svcconn.stormConnections; track storm; let i = $index) {
              <div class="connection-group"
                >
                <h3>Storm Connection #{{i+1}}</h3>
                <div class="key-pair">
                  <span class="label">Location</span>
                  <span>{{sanitize(storm.location)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Size</span>
                  <span>{{sanitize(storm.size,'mm')}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Length</span>
                  <span>{{sanitize(storm.length) | number : '1.2-2'}}m</span>
                </div>
                <div class="key-pair">
                  <span class="label">Material</span>
                  <span>{{sanitize(storm.material)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Ownership</span>
                  <span>{{sanitize(storm.owner)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Installed</span>
                  <span>{{sanitize(storm.year)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Capped</span>
                  <span>{{sanitize(storm.capped)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Capped Date</span>
                  <span>{{sanitize(storm.cappedDate, '', true)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Drawing</span>
                  <span>{{sanitize(storm.drawing)}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Invert Elev</span>
                  <span>{{sanitize(storm.invertElev,'m')}}</span>
                </div>
                <div class="key-pair">
                  <span class="label">Asset ID</span>
                  <span>{{sanitize(storm.assetId)}}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="water mb-4 col-sm-4 px-0 pt-2">
      @if ((propertiesState$ | async).svcconn && (propertiesState$ | async).svcconn.waterConnections) {
        <div>
          @for (water of (propertiesState$ | async).svcconn.waterConnections; track water; let i = $index) {
            <div class="connection-group"
              >
              <h3>Water Connection #{{i+1}}</h3>
              <div class="key-pair">
                <span class="label">Location</span>
                <span>{{sanitize(water.location)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Size</span>
                <span>{{sanitize(water.size,'mm')}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Length</span>
                <span>{{sanitize(water.length) | number : '1.2-2'}}m</span>
              </div>
              <div class="key-pair">
                <span class="label">Material</span>
                <span>{{sanitize(water.material)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Ownership</span>
                <span>{{sanitize(water.owner)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Installed</span>
                <span>{{sanitize(water.year)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Capped</span>
                <span>{{sanitize(water.capped)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Capped Date</span>
                <span>{{sanitize(water.cappedDate, '', true)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Drawing</span>
                <span>{{sanitize(water.drawing)}}</span>
              </div>
              <div class="key-pair">
                <span class="label">Asset ID</span>
                <span>{{sanitize(water.assetId)}}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>